import { TrackingPermissionChecker } from "./TrackingPermissionChecker";
import { getCookieByName } from "@ado/cookie-library";

export class InternalTrackingPermissionChecker
	implements TrackingPermissionChecker
{
	/**
	 * Determines whether tracking data that we send to our own servers should be enabled.
	 *
	 * @returns True or false.
	 */
	isTrackingEnabled(): boolean {
		return (getCookieByName("brand") ?? "").indexOf("library") === -1;
	}
}
